export const LocalStorage = {
  Language: 'language',
  Remember: 'remember',
};

export const CookieStorage = {
  Token: 'XBaht.Token',
};
